var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfLayoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 20",
    fill: "none",
    opacity: 0.712522645,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#E9EBED",
    x: 0,
    y: 0,
    width: 15,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#003346",
    strokeWidth: 2.3328,
    x: 1.1664,
    y: 1.1664,
    width: 12.6672,
    height: 17.6672
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#003346",
    x: 1.74603175,
    y: 5.49019608,
    width: 11.5079365,
    height: 6.71023965
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfLayoutIcon);
export default __webpack_public_path__ + "static/media/HalfLayoutIcon.de7d1ec05915ea0adf02d4d9dadef687.svg";
export { ForwardRef as ReactComponent };